<template lang="pug">
  .nav(:class="{open: Menu.isOpen}")

    .nav-header.dark
      button.hidden-md.hamburger.hamburger--spin(type="button", @click.prevent="switchMenu()", aria-label="Menu", aria-controls="navigation", :class="{'is-active': Menu.isOpen}", tabindex="0")
        span.hamburger-box
          span.hamburger-inner
      router-link.mobile-logo(:to="{name: 'Home', params: {lang: $route.params.lang || 'en'}}")
        img(src="../assets/images/logo.svg", alt="Opeya")

    a.close.hidden-md(href="#", @click.prevent="close", v-if="showClose")

    .nav-menu
      .menu
        ul
          li: router-link.check-link-exact(:to="{name: 'Home', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Accueil") }}
          li
            router-link.hidden-xs.fake-a.check-link(:to="{name: 'Services.List', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Services") }}
            router-link.hidden-md.fake-a.check-link-exact(:to="{name: 'Services.List', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Services") }}
            ul.hidden-md
              li: router-link.check-link-exact(:to="{name: 'Services.Advice', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Conseil") }}
              li: router-link.check-link-exact(:to="{name: 'Services.Investment', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Investissement") }}
              li: router-link.check-link-exact(:to="{name: 'Services.Recruitment', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Recrutement") }}
              li: router-link.check-link-exact(:to="{name: 'Services.Business', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Voyage d'affaire") }}
              li: router-link.check-link-exact(:to="{name: 'Services.Event', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Événementiel") }}

          li: router-link.check-link-exact(:to="{name: 'Team', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Équipe") }}
          li: router-link.check-link-exact(:to="{name: 'Contact', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Contact") }}
      .bottom
        .social
          ul
            li: a(href="https://fb.com/opeyafrance"): img(src="../assets/images/facebook.svg")
            li: a(href="#!"): img(src="../assets/images/wechat.svg")
            li: a(href="https://twitter.com/opeyafrance"): img(src="../assets/images/twitter.svg")
        .dark
          .lang
            a(href="#", @click.prevent="redirect('fr')", :class="{active: $route.params.lang === 'fr'}") Français
            a(href="#", @click.prevent="redirect('zh')", :class="{active: $route.params.lang === 'zh'}") 中文
            a(href="#", @click.prevent="redirect('en')", :class="{active: $route.params.lang === 'en'}") English
          .legal
            router-link(:to="{name: 'Cookies', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Politique d'utilisation des cookies") }}
            | &nbsp;|&nbsp;
            router-link(:to="{name: 'Legal', params: {lang: $route.params.lang || 'en'}}", @click.native="close") {{ $t("Mentions légales") }}
</template>

<script>

import Menu from '../store/Menu'

export default {
  name: 'Nav',
  data () {
    return {
      Menu,
      showClose: false
    }
  },
  methods: {
    close () {
      if (this.Menu.isOpen === true) {
        this.switchMenu(this)
      }
    },
    switchMenu () {
      let that = this

      if (this.Menu.isOpen === true) { // close
        that.Menu.isOpen = false
        setTimeout(function () {
          that.showClose = false
        }, 10)
      } else { // open
        that.showClose = true
        // Add timout for transition opacity when open
        setTimeout(function () {
          that.Menu.isOpen = true
        }, 10)
      }
    },
    redirect (lang) {
      let params = this.$route.params
      params.lang = lang
      this.$router.push({name: this.$route.name, params})
    }
  }
}
</script>

<style lang="scss" scoped>

@import "../scss/config";
@import "../../node_modules/hamburgers/_sass/hamburgers/hamburgers";
$hamburger-layer-width  : 30px;
$hamburger-layer-height : 5px;
$hamburger-layer-spacing: 6px;
$hamburger-layer-color  : $valencia;
@import "../../node_modules/hamburgers/_sass/hamburgers/base";

$arrowSize: 13px;

.hamburger {
  position: absolute;
  right: 10px;
  padding: 11px;
  outline: 0;
}

.dark {
  background-color: $donJuan;
  color: white;

  a {
    color: white;
    text-decoration: none;
  }
}

.nav {
  z-index: 100;
  position: fixed;
  top: 0;

  .nav-header {
    position: fixed;
    height: $menuTopSize;
    top: 0;
    left: 0;
    right: 0;
    z-index: 30;


    background-color: $donJuan;
    text-align: left;

    .mobile-logo {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img {
        height: 40px;
      }
    }

    @include bp(md) {
      height: $menuTopSize * 2;
      .is-home & {
        .mobile-logo img {
          height: 80px;
        }
      }

      .no-home & {
        left: 290px;
        width: 60px;
        right: auto;
        bottom: 0;
        height: auto;

        .mobile-logo {
          top: 250px;
        }
      }
    }
  }

  .close {
    position: fixed;
    display: block;
    background-color: black;
    transition: opacity .3s ease-in-out;
    opacity: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }


  &.open {
    .nav-menu {
      transform: translateX(0);
    }
    .close {
      opacity: .5 !important;
    }
  }


  .nav-menu {
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateZ(0);
    position: fixed;
    padding-top: $menuTopSize;
    top: 0;
    left: 0;
    bottom: 0;
    width: 75%;
    max-width: 400px;
    min-width: 230px;
    transform: translateX(-110%);
    transition: transform .3s ease-in-out;
    overflow-y: auto;
    z-index: 20;
    background-color: $masala;

    box-shadow: 6px 0px 12px 0px rgba(0,0,0,0.45);

    @include bp(md) {
      transform: translateX(0);
      background-color: $wildSand;
      padding-top: 150px;
      box-shadow: none;
      width: 290px;

      @media (max-height: 550px) {
        padding-top: 15px;
      }

      .is-home & {
        transform: translateX(-100%);
      }

      .no-home & {
        transform: translateX(0);
      }
    }

    .menu {
      background-color: $wildSand;
      padding-bottom: 15px;
      ul {
        padding-top: 10px;
        li {
          display: block;
          margin: 10px 15px 0;
          padding: 0;

          a, .fake-a {
            background-color: white;
            color: black;
            padding: 10px;
            text-transform: uppercase;
            font-weight: 700;
            font-size: 1.6rem;
            display: block;
            text-decoration: none;
            text-align: left;
            position: relative;


            @include bp(md) {
              background: none;
              text-align: right;
              font-size: 2rem;
            }
          }

          a {
            &.check-link.router-link-active {
              color: $valencia;
            }

            &.check-link-exact.router-link-exact-active {
              color: $valencia;
            }

            &::before {
              content: "";
              display: block;
              position: absolute;
              right: 10px;
              top: 50%;
              margin-top: -1px;
              height: $arrowSize;
              background-color: $valencia;
              width: $arrowSize;
              transform: rotate(-45deg) translateY(-50%);
            }

            &::after {
              content: "";
              display: block;
              position: absolute;
              right: 13px;
              top: 50%;
              margin-top: -1px;
              height: $arrowSize;
              background-color: white;
              width: $arrowSize;
              transform: rotate(-45deg) translateY(-50%);
            }

            &.fake-a::before,
            &.fake-a::after {
              display: none;
            }

            @include bp(md) {
              &::before, &::after {
                display: none;
              }

              &:hover {
                color: $valencia;
              }
            }

          }

          ul {
            padding-top: 0;
            li {
              background-color: $hintOfRed;
              padding: 0;
              margin: 0 0 1px;
              padding: 0;
              a {
                font-size: 1.4rem;
                font-weight: 600;
                padding: 8px;
                padding-left: 25px;
                background-color: $hintOfRed;
                position: relative;
                &::after, &::before {
                  width: $arrowSize;
                  height: $arrowSize;
                }
                &::after {
                  background-color: $hintOfRed;
                }
              }
            }
          }
        }
      }
    }

    .social {
      background-color: $wildSand;
      padding-top: 10px;
      ul {
        display: flex;
        justify-content: space-around;
        li a {
          display: block;
          padding: 10px;

          img {
            width: 40px;
            transition: transform .1s ease-in-out;
          }

          &:hover img {
            transform: scale(1.3);
          }
        }
      }
    }

    .lang a {
      display: block;
      width: 100%;
      color: white;
      font-size: 1.4rem;
      text-align: center;
      padding: 8px;
      text-decoration: none;

      &.active, &:hover {
        color: $valencia;
      }
    }

    .legal {
      font-size: 1rem;
      text-align: center;
      margin-top: 10px;
      a {
        display: inline-block;
        color: white;
        padding: 8px 8px;
        text-decoration: none;
        &.router-link-exact-active, &:hover {
          color: $valencia;
        }
      }
    }

    @include bp(md) {
      .bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        color: $donJuan;
        border-top: 1px solid $donJuan;

        .dark {
          background: none;
        }

        a {
          color: $donJuan;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// Nav.vue?5ac6621a